module.exports = __webpack_public_path__ + "img/jianguan.e9252f02.jpg";